import React, { Component } from "react";
import { fire, auth } from "../../../firebase/index";
import LocalizedStrings from "react-localization";

let localizationStrings = new LocalizedStrings({
  en: {
    reply1:
      "The batteries are expected to last for 3,500 to 15,000 times turning ON/OFF or over 3 to 5 years of battery life (depends on model), based on 3 to 10 times locking/unlocking per day usage. Typical ON time for eGeeTouch® luggage lock is less than 10 seconds and it turns itself OFF automatically, hence consuming little/no battery power thereafter. Further, it notifies you via your smartphone when batteries run low. The batteries used eGeeTouch smart luggage locks are in compliance with IATA & ICAO directives on safety and security of baggage. For more info on Tests & Certifications, ",
    reply2: "click here",
    back: "Back",
  },
  ja: {
    reply1:
      "バッテリーは、1 日あたり 3 ～ 10 回のロック/ロック解除の使用に基づいて、3,500 ～ 15,000 回の ON/OFF または 3 ～ 5 年のバッテリー寿命 (モデルによって異なる) が期待されます。 eGeeTouch® 荷物ロックの通常のオン時間は 10 秒未満で、自動的にオフになるため、その後はバッテリー電力をほとんどまたはまったく消費しません。さらに、電池が少なくなるとスマートフォンに通知します。 eGeeTouch スマート ラゲッジ ロックに使用されるバッテリーは、手荷物の安全性とセキュリティに関する IATA および ICAO 指令に準拠しています。テストと認定の詳細については、",
    reply2: "ここをクリック",
    back: "戻る",
  },
  es: {
    reply1:
      "Se espera que las baterías duren entre 3500 y 15 000 veces de encendido/apagado o más de 3 a 5 años de duración de la batería (según el modelo), basado en un uso de 3 a 10 veces de bloqueo/desbloqueo por día. El tiempo de encendido típico para el candado de equipaje eGeeTouch® es de menos de 10 segundos y se apaga automáticamente, por lo que consume poca o ninguna energía de la batería a partir de entonces. Además, le notifica a través de su teléfono inteligente cuando las baterías se están agotando. Las baterías utilizadas en los candados de equipaje inteligentes eGeeTouch cumplen con las directivas de la IATA y la OACI sobre seguridad del equipaje. Para obtener más información sobre pruebas y certificaciones, ",
    reply2: "haga clic aquí",
    back: "Atrás",
  },
});

class Q5_component extends Component {
  constructor(props) {
    super(props);

    this.state = {
      triggerValue: "0",
      clicked: false,
      language: "en",
    };
  }

  componentDidMount() {
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          localizationStrings.setLanguage(snapshot.val());
          this.setState({ language: snapshot.val() });
        });
    }
  }

  handleButtonClick2 = () => {
    if (!this.state.clicked) {
      this.setState({ triggerValue: "cancel", clicked: true }, () => {
        this.props.triggerNextStep({
          value: "cancel",
          trigger: "cancel",
        });
      });
    }
  };

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    const buttonStyle = {
      marginTop: "10px",
      width: "215px",
      backgroundColor: "#FFC500",
      color: "black",
      borderRadius: "25px",
      textAlign: "center",
      padding: "10px 10px",
      cursor: "pointer",
      transition: "background-color 0.3s",
      border: "none",
    };

    const buttonHoverStyle = {
      color: "white",
      backgroundColor: "#EF6C00",
    };

    const { triggerValue, clicked } = this.state;

    return (
      <div>
        {localizationStrings.reply1}
        <a
          href="http://www.egeetouch.com/support/certificates"
          target="_blank"
          style={{ textDecoration: "underline", color: "black" }}
        >
          {localizationStrings.reply2}
        </a>
        {this.state.language === "ja" ? "。" : "."}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            margin: "12px 0",
          }}
        >
          <button
            style={{
              ...buttonStyle,
              ...(triggerValue === "cancel" && buttonHoverStyle),
            }}
            onMouseEnter={() => this.setState({ isButtonHovered: true })}
            onMouseLeave={() => this.setState({ isButtonHovered: false })}
            onClick={this.handleButtonClick2}
            disabled={clicked}
          >
            {localizationStrings.back}
          </button>
        </div>
      </div>
    );
  }
}

export default Q5_component;
